import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function PrivateRouteComponent({ children, requiredRole }) {
  const { currentUser, userRole, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Vérifie si requiredRole est un tableau ou une valeur unique
  const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
  
  if (requiredRole && !allowedRoles.includes(userRole)) {
    return <Navigate to="/" />;
  }

  return children;
}

export default PrivateRouteComponent; 